module.exports = __webpack_public_path__ + "static/media/cab-m10.ecacd489.jpg";